import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import FuelConsumptionTable from "./_elements/FuelConsumptionTable";
import {
	IOption,
	IVDMConsumption,
	VDM_DASHBOARD_TABS,
} from "redux/app/vdmdashboard/@types";
import vdmDashboardSelectors from "redux/app/vdmdashboard/selectors";
import vdmDashboardActions from "redux/app/vdmdashboard/actions";
// import FuelConsumptionImpactGraph from "./_elements/FuelConsumptionImpactGraph";
// import FuelConsumptionDistanceCoveredGraph from "./_elements/FuelConsumptionDistanceCoveredGraph";
import FuelConsumptionSpeedMonitoring from "./_elements/fuel-consumption-speed-monitoring/FuelConsumptionSpeedMonitoring";
import FuelConsumptionDistribution from "./_elements/fuel-consumption-distribution/FuelConsumptionDistribution";
// import Select, { components } from "react-select";
import SVGConnect from "components/_common/icons/vdm/SVGConnect";
import classNames from "classnames";
import SVGDownload from "components/_common/icons/vdm/SVGDownload";
import SVGArrow from "components/_common/icons/vdm/SVGArrow";

const VoyageDropdown = () => {
	// <div className="flex justify-between gap-x-2">
	// 							<Select<IOption>
	// 								value={selectedVoyage}
	// 								onChange={(option) => option && setSelectedVoyage(option)}
	// 								options={voyageOptions}
	// 								isSearchable={false}
	// 								isDisabled={true} /* INFO: Not part of phase-1 */
	// 								components={{
	// 									Option: (props) => {
	// 										return (
	// 											<components.Option {...props}>
	// 												{props.data.label}
	// 											</components.Option>
	// 										);
	// 									},
	// 									SingleValue: (props) => {
	// 										return (
	// 											<components.SingleValue {...props}>
	// 												<div className="flex items-center">
	// 													<span className="px-2 pl-1 text-sm text-gray-600">
	// 														<SVGConnect />
	// 													</span>
	// 													<span className="text-sm">{props?.data.label}</span>
	// 												</div>
	// 											</components.SingleValue>
	// 										);
	// 									},
	// 								}}
	// 								classNames={{
	// 									control: ({ isFocused }) =>
	// 										`min-h-0 h-10 border border-gray-300 rounded-lg shadow-none hover:border-gray-400 ${
	// 											isFocused ? "border-blue-500 ring-1 ring-blue-500" : ""
	// 										}`,
	// 									valueContainer: () => "p-0 pl-1",
	// 									indicatorSeparator: () => "hidden",
	// 									dropdownIndicator: () => "p-2",
	// 									menu: () =>
	// 										"mt-1 p-1 rounded-lg border border-gray-200 shadow-lg",
	// 									option: ({ isFocused, isSelected }) =>
	// 										`flex items-center cursor-pointer px-3 py-2 text-sm rounded-md ${
	// 											isFocused ? "bg-blue-50" : "bg-white"
	// 										} ${
	// 											isSelected
	// 												? "bg-blue-100 text-blue-800 font-semibold"
	// 												: "text-gray-700"
	// 										}`,
	// 								}}
	// 							/>
	// 							{/* INFO: Not part of phase-1 */}
	// 							{/* <div className="flex items-center p-1 bg-gray-100 rounded-md border border-gray-200">
	// 								{timePeriods.map((period) => (
	// 									<button
	// 										key={period}
	// 										onClick={() => setActivePeriod(period)}
	// 										className={classNames(
	// 											"px-3.5 py-1.5 text-[12px] font-medium rounded-md transition-colors duration-200 ease-in-out",
	// 											{
	// 												"bg-white text-blue-600 shadow-sm":
	// 													activePeriod === period,
	// 												"text-gray-600 hover:bg-gray-200":
	// 													activePeriod !== period,
	// 											}
	// 										)}
	// 									>
	// 										{period}
	// 									</button>
	// 								))}
	// 							</div> */}
	// 							<button className="flex items-center justify-center bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors p-2 px-2.5">
	// 								<SVGDownload className="w-3 h-3" />
	// 							</button>
	// 						</div>

	return <></>;
};

/* INFO: Not part of phase-1 */
// const SubLoadArrowList: React.FC<{ items: IOption[] }> = ({ items }) => (
// 	<div className="relative ml-6 mt-1">

// 		<div>
// 			{items.map((sub, idx) => (
// 				<div
// 					key={idx}
// 					className="flex items-center text-xs text-gray-500 relative"
// 				>
// 					{/* Horizontal line & arrow */}
// 					<SVGArrow style={{marginBottom: -12}}  className="absolute my-0" />
// 					<div  className="flex items-center ml-8 mt-6 ">
// 						<span className="whitespace-nowrap">{sub.label}:</span>
// 						<span className="ml-1">{sub.value}</span>
// 					</div>
// 				</div>
// 			))}
// 		</div>
// 	</div>
// );

// INFO: Original structure
// const fuelConsumptionByEquipmentTypeData = [
// 	{
// 		equipmentType: "Main Engine",
// 		fuelType: "HFO",
// 		dailyConsumption: "6 MT",
// 	},
// 	{
// 		equipmentType: "Auxiliary Engine",
// 		fuelType: "LSMGO",
// 		dailyConsumption: "10 MT",
// 		subLoads: [
// 			{ label: "Hotel Load", value: "4 MT" },
// 			{ label: "Sea/Harbor Load", value: "2 MT" },
// 			{ label: "Cargo Load", value: "4 MT" },
// 		],
// 	},
// 	{
// 		equipmentType: "Boiler",
// 		fuelType: "LNG",
// 		dailyConsumption: "8 M3",
// 	},
// 	{
// 		equipmentType: "IGG",
// 		fuelType: "VLSFO",
// 		dailyConsumption: "12 M3",
// 	},
// 	{
// 		equipmentType: "Others",
// 		fuelType: "ULSFO",
// 		dailyConsumption: "10 M3",
// 	},
// ];

type OwnProps = {
	vesselId: string;
};
type VDMDashboardConsumptionProps = PropsFromRedux & OwnProps;
function VDMDashboardConsumption(props: VDMDashboardConsumptionProps) {
	const {
		vesselId,
		selectedVDMTab,
		consumption,
		isLoading,
		consumptionByEquipmentType,
		consumptionByFuelType,
	} = props;
	const [graph1Height, setGraph1Height] = useState(380);
	const [activePeriod, setActivePeriod] = useState("1M");
	const timePeriods = ["1M", "6M", "1Y"];

	const voyageOptions: IOption[] = [
		{
			value: "voy-1234",
			label: "VOY 1234",
		},
		{
			value: "voy-5678",
			label: "VOY 5678",
		},
		{
			value: "voy-9012",
			label: "VOY 9012",
		},
	];

	const fuelConsumptionByEquipmentTypeData = consumptionByEquipmentType?.map(
		(equip) => {
			return {
				equipmentType: equip.equipmentType,
				fuelType: equip.fuelType,
				dailyConsumption: equip.consumption,
			};
		},
	);

	const [selectedVoyage, setSelectedVoyage] = useState<IOption | undefined>(
		voyageOptions[0],
	);
	useEffect(() => {
		if (selectedVDMTab === VDM_DASHBOARD_TABS.BUNKER_CONSUMPTION) {
			// props.loadConsumptionTab(vesselId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vesselId, selectedVDMTab]);

	useEffect(() => {
		if (vesselId) {
			// props.loadFuelConsumptionDistanceCovered(vesselId, "24H");
			// props.loadDraftSpeedImpactOnFuelConsumption(vesselId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vesselId, selectedVDMTab]);

	if (isLoading) {
		return (
			<div className="mt-12 flex items-center justify-center">
				<div className="border-4 border-gray-200 border-t-4 border-t-blue-500 rounded-full w-12 h-12 animate-spin"></div>
			</div>
		);
	}

	return (
		<>
			<div className="p-4 sm:p-6  w-full overflow-y-auto ws-scroll">
				{/* INFO: Not part of phase-1 */}
				{/* <section className="flex flex-col lg:flex-row gap-x-4">
					<div className="lg:w-2/3">
						<FuelConsumptionSpeedMonitoring
							graph1Height={graph1Height}
							setGraph1Height={(height) => {
								setGraph1Height(height);
							}}
						/>
					</div>
					<div className="lg:w-1/3">
						<FuelConsumptionDistribution graph1Height={graph1Height} />
					</div>
				</section> */}

				{/* TODO: - Design change were earlier - might need to remove these components */}
				{/* <section>
					<FuelConsumptionDistanceCoveredGraph />
				</section>
				<section>
					<FuelConsumptionImpactGraph />
				</section> */}

				{/* TODO: still unclear how data needs to be rendered */}
				<section>
					{consumptionByFuelType?.length ? (
						<div className="bg-white p-2 sm:p-3 rounded-lg shadow-md border border-gray-200  mx-auto my-5 mt-0">
							<div className="flex justify-between items-center mb-4">
								<h2 className="text-[13px] md:text-base lg:text-lg font-medium text-gray-800">
									Fuel Consumption Breakdown
								</h2>
								<div className="flex justify-between gap-x-2">
									{/* INFO: Not part of phase-1 */}
									{<VoyageDropdown />}
									{/* INFO: Not part of phase-1 */}
									{/* <div className="flex items-center p-1 bg-gray-100 rounded-md border border-gray-200">
									{timePeriods.map((period) => (
										<button
											key={period}
											onClick={() => setActivePeriod(period)}
											className={classNames(
												"px-3.5 py-1.5 text-[12px] font-medium rounded-md transition-colors duration-200 ease-in-out",
												{
													"bg-white text-blue-600 shadow-sm":
														activePeriod === period,
													"text-gray-600 hover:bg-gray-200":
														activePeriod !== period,
												}
											)}
										>
											{period}
										</button>
									))}
								</div> */}
									{/* <button className="flex items-center justify-center bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors p-2 px-2.5">
										<SVGDownload className="w-3 h-3" />
									</button> */}
								</div>
							</div>
							<FuelConsumptionTable
								consumptionByFuelType={consumptionByFuelType}
								fuelData={consumption?.fuelConsumptionBreakdown}
							/>
						</div>
					) : null}
				</section>
				<section>
					{fuelConsumptionByEquipmentTypeData?.length ? (
						<div className="bg-white p-2 sm:p-3 rounded-lg shadow-md border border-gray-200  mx-auto my-5">
							<div className="flex items-center justify-between">
								<h2 className="text-[13px] md:text-base lg:text-lg font-medium text-gray-800">
									Fuel Consumption by Equipment Type
								</h2>
							</div>

							<div className="bg-white rounded-lg overflow-x-auto border border-gray-200 mt-6">
								<table className="w-full">
									<thead>
										<tr className="bg-gray-50">
											<th className="text-left px-4 py-2 font-medium text-gray-600 text-sm">
												Equipment type
											</th>
											<th className="text-left px-4 py-2 font-medium text-gray-600 text-sm">
												Fuel type
											</th>
											<th className="text-left px-4 py-2 font-medium text-gray-600 text-sm">
												Daily Consumption (mt)
											</th>
										</tr>
									</thead>
									<tbody className="text-sm text-gray-700">
										{fuelConsumptionByEquipmentTypeData?.map((row, idx) => (
											<React.Fragment key={idx}>
												<tr className="border-b last:border-b-0">
													<td className="px-4 py-2 align-top">
														<div className="flex flex-col">
															<span>{row.equipmentType}</span>
															{/* INFO: Not part of phase-1 */}
															{/* <div className="ml-6 mt-1 space-y-1">
																{row?.subLoads && (
																	<SubLoadArrowList items={row.subLoads} />
																)}
															</div> */}
														</div>
													</td>
													<td className="px-4 py-2 align-top">
														{row.fuelType}
													</td>
													<td className="px-4 py-2 align-top">
														{row.dailyConsumption}
													</td>
												</tr>
											</React.Fragment>
										))}
									</tbody>
								</table>
							</div>
						</div>
					) : (
						<div className="bg-white p-2 sm:p-3 rounded-lg shadow-md border border-gray-200 mx-auto my-5">
							<div className="text-center py-8 text-gray-500">
								No data available
							</div>
						</div>
					)}
				</section>
			</div>
		</>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vdmDashboardStore = vdmDashboardSelectors._getStore(store);
	const selectedVDMTab =
		vdmDashboardSelectors.getVDMActiveTab(vdmDashboardStore);
	const consumption = vdmDashboardSelectors.getVDMConsumptionData(
		vdmDashboardStore,
	) as Omit<IVDMConsumption, "tabType">;

	const dashboardContent =
		vdmDashboardSelectors?.getVDMDashboardContent(vdmDashboardStore);
	const consumptionByEquipmentType =
		dashboardContent?.bunkerConsumptions?.byEquipmentType;
	const consumptionByFuelType =
		dashboardContent?.bunkerConsumptions?.byFuelType;

	// const jobToLoadConsumption =
	// 	vdmDashboardSelectors.getJobToLoadVDMConsumptionTab(vdmDashboardStore);
	// const jobToLoadFuelConsumptionDistanceCovered =
	// 	vdmDashboardSelectors.getJobToLoadFuelConsumptionDistanceCovered(
	// 		vdmDashboardStore,
	// 	);
	// const jobToLoadDraftSpeedImpactOnFuelConsumption =
	// 	vdmDashboardSelectors.getJobToLoadDraftSpeedImpactOnFuelConsumption(
	// 		vdmDashboardStore,
	// 	);

	const jobToLoadDashboardContent =
		vdmDashboardSelectors.getJobToLoadVDMDashboardContent(vdmDashboardStore);

	const isLoading = jobToLoadDashboardContent.isLoading;
	// 	jobToLoadConsumption?.isLoading ||
	// 	jobToLoadFuelConsumptionDistanceCovered?.isLoading ||
	// 	jobToLoadDraftSpeedImpactOnFuelConsumption?.isLoading;
	return {
		selectedVDMTab,
		consumption,
		isLoading,
		consumptionByEquipmentType,
		consumptionByFuelType,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		loadConsumptionTab: (vesselId: string) => {
			return dispatch(
				vdmDashboardActions.commands.vdmConsumptionTabLoad(vesselId),
			);
		},
		loadFuelConsumptionDistanceCovered: (
			vesselId: string,
			duration: string,
		) => {
			return dispatch(
				vdmDashboardActions.commands.vdmFuelConsumptionDistanceCoveredLoad(
					vesselId,
					duration,
				),
			);
		},
		loadDraftSpeedImpactOnFuelConsumption: (vesselId: string) => {
			return dispatch(
				vdmDashboardActions.commands.vdmDraftSpeedImpactOnFuelConsumptionLoad(
					vesselId,
				),
			);
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardConsumption);
